import React from 'react';
import { FlatList } from 'react-native';
import { createStyleSheet } from '../../../utils';
import { useStyleSheet } from '../../../hooks';
import { Button } from '../../Button';
import { View } from '../../View';
export const Row = ({ style, data, onSend }) => {
    const styles = useStyleSheet(getStyles);
    return (React.createElement(View, { style: style },
        React.createElement(FlatList, { data: data, contentContainerStyle: styles.content, keyExtractor: (item) => item.id, renderItem: ({ item }) => (React.createElement(Button, { type: 'secondary', accent: 'neutral', size: 'md', text: item.name, style: styles.item, onPress: () => {
                    onSend(item);
                } })), horizontal: true, showsHorizontalScrollIndicator: false })));
};
const getStyles = createStyleSheet(({ size }) => ({
    container: {},
    item: {
        marginRight: size.C
    },
    content: {
        paddingHorizontal: size.E
    }
}));
//# sourceMappingURL=Row.js.map